import { forRails } from 'components/for-rails'
import { registerComponents } from '../src/utils/react/registry'
import { ReportsPage } from '../src/pages/reports-page'

registerComponents({
  ReportsPage: forRails(ReportsPage),
})
